export const ArtistsData = [
    {
        image:`https://static.onecms.io/wp-content/uploads/sites/20/2021/02/26/bruno-mars-2.jpg`,
        name:'Bruno Mars',
        description: 'Peter Gene Hernandez, known professionally as Bruno Mars, is an American singer, songwriter, record producer, musician, and dancer.'
    },
    {
        image:`https://media.pitchfork.com/photos/6033c6098b8835d37316a598/16:9/w_3200,h_1800,c_limit/Daft-Punk.jpg`,
        name:'Daft Punk',
        description:'Daft Punk were a French electronic music duo formed in 1993 in Paris by Guy-Manuel de Homem-Christo and Thomas Bangalter.'
    },
    {
        image:`https://www.aljazeera.com/wp-content/uploads/2021/02/2020-02-23T025637Z_1397071560_HP1EG2N086DK6_RTRMADP_3_AWARDS-IMAGE.jpg?resize=770%2C513`,
        name:'Rihanna',
        description:'Robyn Rihanna Fenty is a Barbadian singer, actress, fashion designer, and businesswoman'
    },
    {
        image:`https://www.rollingstone.com/wp-content/uploads/2011/03/britneyspears.jpg?resize=1800,1200&w=1800`,
        name:'Britney Spears',
        description:'Britney Jean Spears is an American singer, songwriter, and dancer.'
    },
    {
        image:`https://nationaltoday.com/wp-content/uploads/2020/09/Beyonce%CC%81s-Birthday.jpg`,
        name:'Beyonce',
        description:'Beyoncé Giselle Knowles-Carter is an American singer, songwriter, and actress.'
    }
    ,
    {
        image:`https://pyxis.nymag.com/v1/imgs/fab/4c6/07665f5f2ce9ebfd378c92723f8262898e-06-whitney-houston.rsquare.w1200.jpg`,
        name:'Whitney Houston',
        description:'Whitney Elizabeth Houston was an American singer and actress.'
    }
    ,
    {
        image:`https://static.independent.co.uk/s3fs-public/thumbnails/image/2020/03/30/12/shutterstock-editorial-138187a.jpg?width=982&height=726&auto=webp&quality=75`,
        name:'Michael Jackson',
        description:'Michael Joseph Jackson was an American singer, songwriter, and dancer.'
    }
    ,
    {
        image:`https://i.scdn.co/image/ab6761610000e5eba00b11c129b27a88fc72f36b`,
        name:'Eminem',
        description:'Marshall Bruce Mathers III, known professionally as Eminem, is an American rapper, songwriter, and record producer.'
    },
    {
        image:`https://www.biography.com/.image/ar_1:1%2Cc_fill%2Ccs_srgb%2Cfl_progressive%2Cq_auto:good%2Cw_1200/MTgwMTgyMjU4NjIyMTQ1ODgw/gettyimages-469873772.jpg`,
        name:'Jennifer Lopez',
        description:'Jennifer Lynn Lopez, also known by her nickname J.Lo, is an American singer, actress, and dancer.'
    },
    {
        image:`https://s.yimg.com/ny/api/res/1.2/UljYBMOWS4s5fjHb706wzQ--/YXBwaWQ9aGlnaGxhbmRlcjt3PTY0MDtoPTQyNw--/https://s.yimg.com/uu/api/res/1.2/GvzCHN_jACqOKQX5Wd114g--~B/aD02ODM7dz0xMDI0O2FwcGlkPXl0YWNoeW9u/https://media.zenfs.com/en/footwear_news_642/5ab0b82bd4445dbdd50364e31aa847c9`,
        name:'Christina Aguilera',
        description:'Christina María Aguilera is an American singer, songwriter, actress, and television personality.'
    },
    {
        image:`https://i2.cinestaan.com/image-bank/1500-1500/62001-63000/62696.jpg`,
        name:'Jagjit Singh',
        description:'Jagjit Singh, born Jagmohan Singh Dhiman, popularly known as "The Ghazal King" or "King of Ghazals", was an Indian composer, singer and musician.'
    },
    {
        image:`https://pbs.twimg.com/profile_images/1346569733454376971/LUBieasg_400x400.jpg`,
        name:'Mariah Carey',
        description:'Mariah Carey is an American singer-songwriter and actress.'
    }
]